var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "420pt",
    viewBox: "0 -7 420 420",
    width: "420pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d4e1f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m212 108h40v75h-40zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311 9h40v69h-40zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108 213h40v67h-40zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 366v-56h-40v86h402v-30zm0 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m151.835938 88.636719c-4.972657 0-9-4.027344-9-9v-41h-41c-4.972657 0-9-4.027344-9-9 0-4.96875 4.027343-9 9-9h50c4.96875 0 9 4.03125 9 9v50c0 4.972656-4.03125 9-9 9zm0 0",
    fill: "#2eca8b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m48.164062 143.363281c-3.636718 0-6.917968-2.195312-8.3125-5.554687-1.394531-3.363282-.625-7.234375 1.949219-9.808594l103.238281-103.238281c3.515626-3.515625 9.214844-3.515625 12.730469 0 3.511719 3.515625 3.511719 9.210937 0 12.726562l-103.238281 103.238281c-1.6875 1.691407-3.976562 2.636719-6.367188 2.636719zm0 0",
    fill: "#2eca8b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m411 0h-100c-4.96875 0-9 4.03125-9 9v90h-90c-4.96875 0-9 4.03125-9 9v96h-95c-4.96875 0-9 4.03125-9 9v88h-90c-4.96875 0-9 4.03125-9 9v86c0 4.96875 4.03125 9 9 9h402c4.96875 0 9-4.03125 9-9v-387c0-4.96875-4.03125-9-9-9zm-9 387h-384v-68h90c4.96875 0 9-4.03125 9-9v-88h95c4.96875 0 9-4.03125 9-9v-96h90c4.96875 0 9-4.03125 9-9v-90h82zm0 0",
    fill: "#2f55d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.6c9da41b039b36793b8916bfcd5b2451.svg";
export { ForwardRef as ReactComponent };